import {
  ResourceAllocationType,
  ResourceSelectionMode,
  TierPricingType,
} from "../../../GeneratedGraphQL";

import { AppData } from "../../AppDataProvider";
import { CompleteMultiTierStepPayload } from "../../actions";
import { Mixpanel } from "../../../mixpanel";

export type CompleteMultiTierStepOpts = {
  appData: AppData;
  payload: CompleteMultiTierStepPayload;
};

export const completeMultiTierStep = ({
  appData,
  payload,
}: CompleteMultiTierStepOpts): AppData => {
  Mixpanel.track({ name: "Completed step", props: { step: "multiTier" } });

  const { bookingData, bookingTool } = appData;
  const { tier } = payload.updatedData;
  const updatedBookingData = {
    ...bookingData,
    tier,
  };

  const resourceSelectionBeforeAvailability =
    bookingData.organisation?.resourceSelectionBeforeAvailability;

  const getNextStep = () => {
    if (tier.pricingType === TierPricingType.Multiple) {
      return "pricePoints";
    }

    /**
     * If we have been provided a resourceId in the url params,
     * we do not want to go to the resource step. We also do
     * not want to go to the resource step if there is only
     * one resource to choose from.
     */
    const urlParams = new URLSearchParams(window.location.search);
    const preFillResourceId = urlParams.get("resourceId");
    const resourcesOnService = bookingData.service?.numberOfResources;

    if (
      bookingTool.resourceSelectionMode !== ResourceSelectionMode.Disabled &&
      resourceSelectionBeforeAvailability &&
      !preFillResourceId &&
      resourcesOnService &&
      resourcesOnService > 1 &&
      bookingData.service?.resourceAllocationType === ResourceAllocationType.Any
    ) {
      return "resources";
    }
    return "availability";
  };

  return {
    ...appData,
    bookingData: updatedBookingData,
    currentStep: getNextStep(),
  };
};
